import isProduction from './isProduction';

const PROD_APP_LINK = 'https://play.google.com/store/apps/details?id=com.sprinterhealthapp';
const TESTNET_APP_LINK =
  'https://play.google.com/store/apps/details?id=com.sprinterhealthapp&hl=en-US&ah=2ef0mKfLakGD7KjOsG0aR_U6Cas';

export default function getAndroidAppInstallURL(): string {
  return isProduction() ? PROD_APP_LINK : TESTNET_APP_LINK;
}
